/* eslint-disable import/no-cycle */
/* eslint-disable camelcase */

import { ACTION_PLAN_STATE_SLICE_KEY } from './constants';

import {
	addGroupToRangeGroups,
	removeGroupFromRangeGroups
} from '../../../utils/readingRangeGroups';
import {
	selectActionPlanStateCustomGroups,
	selectActionPlanStateRemediationActions,
	selectActionPlanStateLessNegativeThreshold,
	selectActionPlanStateUseShadow,
	selectActionPlanStateVersion,
	selectActionPlanStateComparator,
	selectActionPlanStateMoreNegativeThreshold
} from './selectors';
import {
	receiveActionPlanState,
	setActionReportVersion,
	setActionReportComparator,
	setActionReportLessNegativeThreshold,
	setActionReportMoreNegativeThreshold,
	setActionReportUseShadow,
	addActionReportCustomGroup,
	removeActionReportCustomGroup,
	clearActionReportCustomGroup
} from './actions';

// ************
// PARTS
// ************
const reducerParts = {
	[receiveActionPlanState]: (state, { payload: { actionPlanState } }) => {
		const result = {
			...state,
			isFetchingActionPlanState: false,
			isActionPlanStateLoaded: true,
			[ACTION_PLAN_STATE_SLICE_KEY]: actionPlanState
		};

		if (actionPlanState && Object.keys(actionPlanState).length > 0) {
			const version = selectActionPlanStateVersion({ actionPlanState });
			const comparator = selectActionPlanStateComparator({
				actionPlanState
			});
			const lessNegativeThreshold = selectActionPlanStateLessNegativeThreshold({ actionPlanState });
			const moreNegativeThreshold = selectActionPlanStateMoreNegativeThreshold({ actionPlanState });
			const useShadow = selectActionPlanStateUseShadow({ actionPlanState });
			const remediationActions = selectActionPlanStateRemediationActions({
				actionPlanState
			});
			const customGroups = selectActionPlanStateCustomGroups({
				actionPlanState
			});
			result.actionReportVersion = version;
			result.actionReportComparator = comparator;
			result.actionReportLessNegativeThreshold = lessNegativeThreshold;
			result.actionReportMoreNegativeThreshold = moreNegativeThreshold;
			result.actionReportUseShadow = useShadow;
			if (remediationActions) {
				result.actionReportRemediationActions = remediationActions;
			}
			if (customGroups) {
				result.actionReportCustomGroups = customGroups;
			}
		}

		return result;
	},

	// @todo - this should be managed inside the action plan state object
	[setActionReportVersion]: (
		state,
		{ payload: { version: actionReportVersion } }
	) => {
		return { ...state, actionReportVersion };
	},

	// @todo - this should be managed inside the action plan state object
	[setActionReportComparator]: (
		state,
		{ payload: { comparator: actionReportComparator } }
	) => {
		return { ...state, actionReportComparator };
	},

	// @todo - this should be managed inside the action plan state object
	[setActionReportLessNegativeThreshold]: (
		state,
		{ payload: { lessNegativeThreshold: actionReportLessNegativeThreshold } }
	) => {
		return { ...state, actionReportLessNegativeThreshold: +actionReportLessNegativeThreshold };
	},

	[setActionReportMoreNegativeThreshold]: (
		state,
		{ payload: { moreNegativeThreshold: actionReportMoreNegativeThreshold } }
	) => {
		return { ...state, actionReportMoreNegativeThreshold: +actionReportMoreNegativeThreshold };
	},

	// @todo - this should be managed inside the action plan state object
	[setActionReportUseShadow]: (
		state,
		{ payload: { useShadow: actionReportUseShadow } }
	) => {
		return { ...state, actionReportUseShadow };
	},

	// @todo - this should be managed inside the action plan state object
	[addActionReportCustomGroup]: (state, { payload: { group } }) => {
		return {
			...state,
			actionReportCustomGroups: addGroupToRangeGroups(
				group,
				state.actionReportCustomGroups
			)
		};
	},

	// @todo - this should be managed inside the action plan state object
	[removeActionReportCustomGroup]: (state, { payload: { group } }) => {
		return {
			...state,
			actionReportCustomGroups: removeGroupFromRangeGroups(
				group,
				state.actionReportCustomGroups
			)
		};
	},

	// @todo - this should be managed inside the action plan state object
	[clearActionReportCustomGroup]: state => {
		return {
			...state,
			actionReportCustomGroups: []
		};
	}
};

export default reducerParts;
